import SearchableMultiSelectController from "./searchable_multi_select_controller"

// Shows a native single <select> as a searchable slim-select widget, for lists
// too long to scroll comfortably -- the misc charge form's Charge Type.
//
// Everything that makes the widget reachable and named -- the tab stop, the
// combobox role, aria-expanded, the label, Enter/Space/ArrowDown to open,
// Escape to close, and putting the select back on teardown -- is inherited from
// searchable_multi_select_controller.js, which documents why slim-select v1
// needs each of them. Nothing there assumes `multiple`; the Clear button is
// optional and this controller has none.
//
// slim-select writes the choice back to the native select and fires a
// bubbling `change` on it, so actions bound to the select keep working.
//
// Usage:
//   <div data-controller="searchable-select">
//     <label for="charge_type_id">Charge Type</label>
//     <select id="charge_type_id" name="charge_type_id"
//             data-target="searchable-select.select">...</select>
//   </div>
export default class extends SearchableMultiSelectController {}
